import { useState } from "react";
import ReactTooltip from "react-tooltip";
import { Countries } from "..";
import { StyledLink } from "../../utils/button";
import { orderHistory } from "../../data/account/allcourse";
import { BsInfoCircleFill } from "react-icons/bs";
import { HiCheckCircle } from "react-icons/hi";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import "../../styles/Dashboard/tabs.css";
import { selectUser } from "../../services/userSlice";
import { useSelector } from "react-redux";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  className?: string;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component={"span"}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const user = useSelector(selectUser);
  const [value, setValue] = useState(0);

  const [formData, setformData] = useState({
    email: user?.email,
    name: user?.displayName,
    password: "update password",
    country: "Nigeria",
  });

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const handleFormChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setformData((prevFormData) => {
      return {
        ...prevFormData,
        [name]: value,
      };
    });
  };

  const data = orderHistory.map((course, i) => (
    <div
      key={i}
      className="tabs-card"
    >
      <img
        src={course.banner}
        width="91"
        height="81"
        alt="course"
      />
      <div>
        <h4>{course.title}</h4>
        <p>{course.duration}</p>
        {course.isSuccessful && (
          <p className="success">
            {course.transactionHistory}{" "}
            <HiCheckCircle style={{ color: "var(--vidomCustomBlue)" }} />
          </p>
        )}
        {!course.isSuccessful && (
          <div className="decline-cont">
            <p className="decline">{course.transactionHistory} </p>
            <div
              data-tip
              data-for="tab-tooltip"
            >
              <BsInfoCircleFill
                style={{ color: "var(--vidomGray)", cursor: "pointer" }}
              />
              <ReactTooltip
                className="tab-tooltip"
                id="tab-tooltip"
                aria-haspopup="true"
                effect="solid"
                type="light"
              >
                <div className="hover-modal">
                  <p>
                    We had some issue processing <br />
                    your payment. Kindly make a <br />
                    fresh order.{" "}
                  </p>
                </div>
              </ReactTooltip>
            </div>
          </div>
        )}
      </div>
    </div>
  ));

  return (
    <Box sx={{ width: "100%" }}>
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="basic tabs example"
        className="tabs container"
      >
        <Tab
          className="tab1"
          label="My Profile"
          {...a11yProps(0)}
          sx={{
            textTransform: "capitalize",
            fontWeight: 400,
            color: "var(--vidomGray)",
          }}
        />
        <Tab
          className="tab2"
          label="Order History"
          {...a11yProps(1)}
          sx={{
            textTransform: "capitalize",
            fontWeight: 400,
            color: "var(--vidomGray)",
          }}
        />
      </Tabs>

      <TabPanel
        value={value}
        index={0}
        className="tabs-content-container"
      >
        <div className="tabs-container">
          <h4>Edit Profile</h4>
          <p>Click on any of the fields to update your details</p>
          <form
            onSubmit={handleSubmit}
            className="user-details-form"
          >
            <div className="user-details-form-cont">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                name="email"
                onChange={handleFormChange}
                placeholder={formData.email}
                value={formData.email}
                autoComplete="off"
              />
            </div>
            <div className="user-details-form-cont">
              <label htmlFor="name">Name</label>
              <input
                type="text"
                name="name"
                onChange={handleFormChange}
                placeholder={formData.name}
                value={formData.name}
                autoComplete="off"
              />
            </div>
            <div className="user-details-form-cont">
              <label htmlFor="password">Password</label>
              <input
                type="text"
                name="password"
                onChange={handleFormChange}
                placeholder="update password"
                value={formData.password}
                autoComplete="off"
              />
            </div>

            <div className="user-details-form-cont">
              <label htmlFor="country">Country</label>
              <Countries />
            </div>

            <StyledLink
              as="button"
              className="save-changes"
            >
              Save Changes
            </StyledLink>
          </form>
        </div>
      </TabPanel>
      <TabPanel
        value={value}
        index={1}
        className="tabs-content-container"
      >
        {data}
      </TabPanel>
    </Box>
  );
}
